/**
 * SubscribeToUserDeviceChangesUseCase
 *
 * Flutter parity: lib/services/app_authentication_service.dart:612-648.
 *
 * Thin pass-through to `UserDeviceService.subscribeToDeviceChanges`. The
 * service owns the parity rules (modified-only changes, null-local-id
 * guard, break-after-first-mismatch). This use case only wires the
 * subscription so presentation-layer listener components can request a
 * device-mismatch signal without reaching into the domain service directly.
 *
 * The sign-out side-effect is intentionally NOT performed here — the caller
 * (the listener component / auth-aware page) is responsible for invoking
 * the auth service when `onMismatch` fires, mirroring how Flutter calls
 * `logOut()` from inside the stream listener rather than from a deeper
 * service.
 */
import { UserDeviceService } from '@/domain/services/userDevice/userDeviceService';
import type { Unsubscribe } from 'firebase/firestore';

export class SubscribeToUserDeviceChangesUseCase {
  execute(userId: string, onMismatch: () => void): Promise<Unsubscribe> {
    return UserDeviceService.subscribeToDeviceChanges(userId, onMismatch);
  }
}
